import { render, staticRenderFns } from "./TosTable.vue?vue&type=template&id=507e9a98"
import script from "./TosTable.vue?vue&type=script&lang=js"
export * from "./TosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports